import styles from './index.module.less'
import Title from '@/components/BlockTitleTwo'
import icon from '@/assets/image/gea/verifynodes.svg'
import SearchInput from '@/components/SearchInputTwo'
import BlockTitle from '@/components/BockTitle'
import CardInfoTwo from '../components/cardInfoTwo/index'
import CrdInfoThree from '../components/cardInfoThree/index'
import SlideBtn, { type IbtnListItem } from '@/components/SlideBtn'
import { useEffect, useMemo, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams, useSearchParams } from 'react-router-dom'
import {
  getRollappTxDetail,
  getTransactionDetail,
  getTransactionRawLog,
  getTransactionRawLogCheckIn,
  getTransactionRawLogRollapp,
} from '@/api/transactionList'
import {
  RollappTxDetail_Transaction,
  RollappTxDetail_TransactionData,
  TransactionDetailData,
} from '@/api/transactionList/interface'
import ReactJson from 'react-json-view'
import { transactionTypeArray } from '../utils'
import LoadingCom from '@/components/LoadingCom'
const TransitionCard = () => {
  const { t } = useTranslation()
  const params = useParams()
  const searchParams = useSearchParams()
  const netType = searchParams[0].get('net_type') || 'hub'
  const address = searchParams[0].get('address') || ''
  const accountAssetChangeLogPromiseSingle = useRef<any>(null)
  const getCommitteeElectionVoteInfoPromise = useRef<any>(null)
  const [loading, setLoading] = useState<boolean>(true)
  const [btnList, setBtnList] = useState<IbtnListItem[]>([
    {
      // 概述
      name: t('explorer_97'),
      value: '0',
      active: true,
    },
    {
      name: t('explorer_98'),
      value: '1',
      active: false,
    },
  ])

  const [transactionDetail, setTransactionDetail] = useState<
    TransactionDetailData | RollappTxDetail_Transaction
  >()
  const [orgTransactionDetail, setOrgTransactionDetail] = useState<any>()
  const [rawLog, setRawLog] = useState<{ [key: string]: any } | null>(null)
  const [rawLogLoad, setRawLogLoad] = useState<boolean>(false)
  const [network, setNetwork] = useState<string>('')

  async function getDetail(dynamic: string) {
    setLoading(true)
    const fn = netType === 'hub' ? getTransactionDetail : getRollappTxDetail
    const res: any = await fn(dynamic)
    if (res?.transaction && netType === 'hub') {
      setNetwork(res?.transaction?.network)
      setTransactionDetail(res?.transaction as TransactionDetailData)
      const msgs = (res.transaction as TransactionDetailData)?.msgs || []
      const data = msgs.map((item: any) => {
        const oriDetailData = JSON.parse(JSON.stringify(res))?.transaction || {}
        oriDetailData.msgs = [item]
        return {
          transaction: oriDetailData,
        }
      })
      const filterData = data.filter((item) => {
        const type = item.transaction.msgs[0].type
        return transactionTypeArray.includes(type)
      })
      const filterDataBackup = JSON.parse(JSON.stringify(filterData))
      filterData.forEach((item, index) => {
        const type = item.transaction.msgs[0].type
        if (type === 'gea.staking.MsgKycUsersTransferToNewRegion') {
          let delegate_interest_info = item.transaction.msgs[0].detail?.delegate_interest_info
          if (!Array.isArray(delegate_interest_info)) return
          if (address) {
            delegate_interest_info = delegate_interest_info.filter(
              (i: any) => i.account === address,
            )
          }
          const newV = delegate_interest_info.map((i: any) => {
            const itemBackup = JSON.parse(JSON.stringify(item))
            itemBackup.transaction.msgs[0].detail.delegate_interest_info = null
            itemBackup.transaction.msgs[0].detail.delegate_interest_info = i
            const addressData = i.account
            const AGRAGEDATA = item.transaction.msgs[0].detail[addressData]
            if (AGRAGEDATA) {
              itemBackup.transaction.msgs[0].detail.delegate_interest_info.subInfo = AGRAGEDATA
            }
            return itemBackup
          })
          filterDataBackup.splice(index, 1, ...newV)
        }
      })
      setOrgTransactionDetail(filterDataBackup)
    }
    if (
      (res as unknown as RollappTxDetail_TransactionData)?.tx &&
      ['rollup', 'rollup_checkin'].includes(netType)
    ) {
      setNetwork((res as unknown as RollappTxDetail_TransactionData).network?.[0]?.value || '')
      setTransactionDetail((res as unknown as RollappTxDetail_TransactionData).tx[0])
      setOrgTransactionDetail([{ tx: (res as unknown as RollappTxDetail_TransactionData).tx }])
    }
    setLoading(false)
  }

  const getRawLog = async () => {
    const fn = netType === 'hub' ? getTransactionRawLog : getTransactionRawLogRollapp
    const res = await fn(params.dynamic as string)
    setRawLog({
      ...transactionDetail,
      ...res,
    })
    setRawLogLoad(true)
  }

  useEffect(() => {
    if (btnList[1].active && !rawLogLoad) {
      getRawLog()
    }
  }, [btnList])

  useEffect(() => {
    accountAssetChangeLogPromiseSingle.current = null
    getCommitteeElectionVoteInfoPromise.current = null
    getDetail(params.dynamic as string)
    setBtnList([
      {
        // 概述
        name: t('explorer_97'),
        value: '0',
        active: true,
      },
      {
        // 消息
        name: t('explorer_98'),
        value: '1',
        active: false,
      },
    ])
  }, [params.dynamic])

  const showMessage = useMemo(() => {
    // let type = ''
    if (netType === 'hub') {
      return orgTransactionDetail?.length > 0
    } else {
      const type = orgTransactionDetail?.[0]?.tx?.[0]?.msgs?.[0]?.type
      const arr: string[] = [
        // 'gea.kyc.MsgUpdateDidInfo',
        // 'ibc.core.client.v1.MsgUpdateClient',
        // 'ibc.core.client.v1.MsgCreateClient',
      ]
      return orgTransactionDetail?.length > 0 && !arr.includes(type)
      // type = orgTransactionDetail?.[0]?.transaction?.messages?.[0]['@type'] || ''
      // if (type.startsWith('/')) {
      //   type = type.slice(1)
      // }
    }
    // return transactionTypeArray.includes(type)
  }, [orgTransactionDetail])

  return (
    <div className={styles.wrap}>
      <div className={styles.titleWrap}>
        {/* 交易详情 */}
        {/* icon={icon}  */}
        <Title title={t('explorer_151')} />
        <div className="search_input">
          <SearchInput placeholder={t('explorer_8')} />
        </div>
      </div>
      <div className={styles.BlockTitleWrap}>
        {/* 详情 */}
        <BlockTitle title={t('explorer_152')}></BlockTitle>
        <div className={styles.slideBtn}>
          {!loading && <SlideBtn btnList={btnList} setBtnList={setBtnList} />}
        </div>
      </div>
      <div className={styles.cardInfoWrap}>
        {btnList[0].active ? (
          <CardInfoTwo
            network={network}
            loading={loading}
            data={transactionDetail}
            style={{ marginTop: 0 }}
          />
        ) : null}
        {btnList[1].active ? (
          <div className={'globalJsonWrap'}>
            {rawLogLoad ? (
              <ReactJson
                collapsed={4}
                displayObjectSize={false}
                src={rawLog || {}}
                iconStyle={'triangle'}
                theme={'apathy'}
                displayDataTypes={false}
              />
            ) : (
              <div className={'loadingWrap'}>
                <LoadingCom></LoadingCom>
              </div>
            )}
          </div>
        ) : null}
      </div>

      {showMessage ? (
        <>
          {/* TODO: 消息这一期提测不显示 */}
          <BlockTitle title={t('explorer_153')}></BlockTitle>
          {orgTransactionDetail?.map((item: any, index: number) => {
            return (
              <CrdInfoThree
                accountAssetChangeLogPromiseSingle={accountAssetChangeLogPromiseSingle}
                getCommitteeElectionVoteInfoPromise={getCommitteeElectionVoteInfoPromise}
                showGasFee={index === orgTransactionDetail?.length - 1}
                key={index}
                transactionDetail={item as any}
              />
            )
          })}
          {/* <CrdInfoThree transactionDetail={orgTransactionDetail as any} /> */}
        </>
      ) : null}
    </div>
  )
}

export default TransitionCard
